import React from 'react';
import { Form1008Data, ValidationErrors } from '../../types';
import { TextInput, NumberInput, CurrencyInput, PercentInput, Select, SegmentedControl } from '../ui/Inputs';
interface Props {
  data: Form1008Data;
  onChange: (field: keyof Form1008Data, value: any) => void;
  errors: ValidationErrors;
}
export function Section2({
  data,
  onChange,
  errors
}: Props) {
  return <div className="space-y-3" data-id="element-85">
      <div data-id="element-86">
        <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-87">
          Loan Details
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2" data-id="element-88">
          <Select label="Loan Type" value={data.loanType} onChange={v => onChange('loanType', v)} required error={errors.loanType} options={[{
          label: 'Conventional',
          value: 'conventional'
        }, {
          label: 'FHA',
          value: 'fha'
        }, {
          label: 'VA',
          value: 'va'
        }, {
          label: 'USDA / RD',
          value: 'usda'
        }]} data-id="element-89" />
          <Select label="Amortization Type" value={data.amortizationType} onChange={v => onChange('amortizationType', v)} required error={errors.amortizationType} options={[{
          label: 'Fixed-Rate — Monthly',
          value: 'fixedMonthly'
        }, {
          label: 'Fixed-Rate — Biweekly',
          value: 'fixedBiweekly'
        }, {
          label: 'Balloon',
          value: 'balloon'
        }, {
          label: 'ARM',
          value: 'arm'
        }, {
          label: 'Other',
          value: 'other'
        }]} data-id="element-90" />
          <Select label="Loan Purpose" value={data.loanPurpose} onChange={v => onChange('loanPurpose', v)} required error={errors.loanPurpose} options={[{
          label: 'Purchase',
          value: 'purchase'
        }, {
          label: 'Cash-Out Refinance',
          value: 'cashOut'
        }, {
          label: 'Refinance No Cash-Out',
          value: 'rateTerm'
        }]} data-id="element-91" />
          <SegmentedControl label="Lien Position" value={data.lienPosition} onChange={v => onChange('lienPosition', v)} required error={errors.lienPosition} options={[{
          label: 'First',
          value: 'first'
        }, {
          label: 'Second',
          value: 'second'
        }]} data-id="element-92" />
        </div>
      </div>

      <div className="pt-3 border-t border-slate-100" data-id="element-93">
        <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-94">
          Note Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-2" data-id="element-95">
          <CurrencyInput label="Loan Amount" value={data.loanAmount} onChange={v => onChange('loanAmount', v)} required error={errors.loanAmount} data-id="element-96" />
          <PercentInput label="Note Rate" value={data.noteRate} onChange={v => onChange('noteRate', v)} required error={errors.noteRate} data-id="element-97" />
          <NumberInput label="Loan Term" value={data.loanTermMonths} onChange={v => onChange('loanTermMonths', v)} required error={errors.loanTermMonths} helperText="in months" data-id="element-98" />
          <CurrencyInput label="Amount of Subordinate Financing" value={data.subordinateAmount} onChange={v => onChange('subordinateAmount', v)} helperText="Incl. HELOC balance + limit" data-id="element-99" />
        </div>
      </div>

      <div className="pt-3 border-t border-slate-100" data-id="element-100">
        <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-101">
          Origination & Buydown
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-2" data-id="element-102">
          <Select label="Mortgage Originator" value={data.mortgageOriginator} onChange={v => onChange('mortgageOriginator', v)} required error={errors.mortgageOriginator} options={[{
          label: 'Seller',
          value: 'seller'
        }, {
          label: 'Broker',
          value: 'broker'
        }, {
          label: 'Correspondent',
          value: 'correspondent'
        }]} data-id="element-103" />
          <SegmentedControl label="Temporary Buydown" value={data.tempBuydown} onChange={v => onChange('tempBuydown', v)} options={[{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }]} data-id="element-104" />
          <TextInput label="Buydown Terms" value={data.tempBuydown ? data.buydownTerms : ''} onChange={v => onChange('buydownTerms', v)} disabled={!data.tempBuydown} placeholder={data.tempBuydown ? 'e.g. 2-1' : '—'} helperText={!data.tempBuydown ? 'N/A' : undefined} data-id="element-105" />
          <TextInput label="Broker / Correspondent Name & Company" value={data.brokerName} onChange={v => onChange('brokerName', v)} className="md:col-span-2" data-id="element-106" />
        </div>
      </div>
    </div>;
}